import React, { Component } from "react";
import Icon from "./Icons";
import { validName } from "../functions";

export default class SaveDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      actions: false,
    };
  }

  render() {
    return (
      (this.state.renaming && (
        <div
          className={`custom-list active ${
            this.props.content[1] ? "normal" : "middle"
          }`}
        >
          <div className="gk-rename-field">
            <input
              type="text"
              value={this.props.content[0]}
              onChange={(e) => {
                this.props.rename.onChange(this.props.itemKey, e.target.value);
              }}
            />
            <button
              className="save"
              onClick={() => {
                this.setState(
                  {
                    renaming: false,
                  },
                  () => {
                    this.props.rename.onSave(
                      this.props.index,
                      this.props.itemKey,
                      this.props.content[0]
                    );
                  }
                );
              }}
              disabled={!validName(this.props.content[0])}
            >
              <Icon icon="check" />
            </button>
          </div>
        </div>
      )) || (
        <div
          className={`custom-list hover ${this.props.active ? "active" : ""} ${
            this.props.content[1] ? "normal" : "middle"
          }`}
          onClick={() => {
            this.props.onClick();
          }}
        >
          {!this.props.readOnly && this.props.draggable && (
            <div className="move">
              <Icon icon="move" />
            </div>
          )}
          <div className="content">
            <div className={!this.props.draggable ? "left" : ""}>
              <span className="large">{this.props.content[0]}</span>
              {this.props.content[1] && (
                <span className="small">{this.props.content[1]}</span>
              )}
            </div>
          </div>
          {!this.props.readOnly &&
            ((this.props.actions && this.props.actions.length > 0) ||
              this.props.rename) && (
              <div
                className="dots"
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ actions: !this.state.actions });
                }}
              >
                <Icon icon="dots" />
              </div>
            )}
          {!this.props.readOnly &&
            ((this.props.actions && this.props.actions.length > 0) ||
              this.props.rename) &&
            this.state.actions && (
              <div
                className="actions"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                {this.props.rename && (
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setState({ renaming: true });
                    }}
                  >
                    {this.props.rename.label}
                  </div>
                )}
                {this.props.actions &&
                  this.props.actions.length > 0 &&
                  this.props.actions.map((action, index) => (
                    <div
                      key={index}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({ actions: false }, () => {
                          action.action();
                        });
                      }}
                    >
                      {action.label}
                    </div>
                  ))}
              </div>
            )}
          {this.props.warning && (
            <span className="warning">{this.props.warning}</span>
          )}
        </div>
      )
    );
  }
}
